import styled from 'styled-components';

const FieldActionMenuItemWrapper = styled.span`
  padding: ${(props): string => props.theme.spaces.sm};
`;

export { FieldActionMenuItemWrapper };
